import { render, staticRenderFns } from "./UserProfileSkeleton.vue?vue&type=template&id=58ca482e&scoped=true&"
import script from "./UserProfileSkeleton.vue?vue&type=script&lang=ts&"
export * from "./UserProfileSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileSkeleton.vue?vue&type=style&index=0&id=58ca482e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca482e",
  null
  
)

export default component.exports